import axiosWrapper from '@/utils/request'
import store from '../store'
import axios from 'axios'

const accountId = () => store.getters.accountId

const fetchLoggedUser = (token) => {
  return axiosWrapper({
    method: 'GET',
    url: '/v1/access/users/me?include[]=linked_users',
    headers: { Authorization: 'Bearer ' + token }
  })
}

const authenticateAccount = (token) => {
  return axios({
    method: 'get',
    url: `${process.env.VUE_APP_DRIP_WEB_HOST}/accounts/session`,
    params: {
      token: token,
      vue: true
    }
  })
}

const signInAccount = (token, formData) => {
  return axios({
    method: 'POST',
    url: `${process.env.VUE_APP_DRIP_API_HOST}/access/sessions`,
    headers: { Authorization: 'Token ' + token },
    data: {
      user: formData
    }
  })
}

const signOutAccount = () => {
  return axiosWrapper({
    url: `${process.env.VUE_APP_DRIP_WEB_HOST}/accounts/sign-out`,
    withCredentials: true,
    params: {
      vue: true
    }
  })
}

const fetchBusinessAccount = (params) => {
  return axiosWrapper({
    url: `/v1/business/accounts/${accountId()}`,
    params
  })
}

const getExporterAccountData = (exporterId) => {
  return axiosWrapper({
    method: 'GET',
    url: `/v1/business/exporters/${exporterId}`
  })
}

export const pricingBannerInteraction = (data) => {
  return axiosWrapper({
    url: `/v1/interaction_metadata`,
    method: 'POST',
    data
  })
}

const fetchInsight = () => {
  return axiosWrapper({
    url: `${process.env.VUE_APP_DRIP_WEB_HOST}/insights/api/v1/access/drip`
  })
}

const addFreshDeskURL = (data) => {
  return axiosWrapper({
    url: 'v1/access/users/me/call/freshdesk_sso_token',
    method: 'POST',
    data
  })
}

const deleteToken = () => {
  return axiosWrapper({
    url: `/access/sessions`,
    method: 'DELETE'
  })
}

export default {
  signOutAccount,
  fetchBusinessAccount,
  fetchInsight,
  addFreshDeskURL,
  deleteToken,
  pricingBannerInteraction,
  getExporterAccountData,
  signInAccount,
  fetchLoggedUser,
  authenticateAccount
}
